module.exports = __webpack_public_path__ + "img/lnk-clients-footer.8554d14f.svg";